
<script setup>

  import { ref, watch, onMounted } from 'vue';

  import { useRoute } from 'vue-router';

  import { PlayCircleIcon } from '@heroicons/vue/24/outline';

  import { seenPlayerDialog, seenSaveDialog } from '../stores/activity-1.js';

  import VideoPlayerDialog from '../dialogs/video-player.vue';

  import SaveDialog from '../dialogs/save.vue';

  import videoPath from '../video/activity-1.mp4';

  import captionsPath from '../video/activity-1-captions.vtt';

  import descriptionsPath from '../video/activity-1-descriptions.vtt';

  import backgroundPath from '../images/paper-background.jpg';

  const props = defineProps( { buttons: Object } );

  const route = useRoute();

  const playerDialog = ref( null );

  const saveDialog = ref( null );

  onMounted( () =>

    watch( () => route.path, () => {

      seenPlayerDialog.value = false;

      playerDialog.value.close();

      if ( route.path === '/activity/1/intro' )

        playerDialog.value.open().then( () => seenPlayerDialog.value = true );

      if ( ! seenSaveDialog.value && route.path === '/activity/1/photo/1' )

        saveDialog.value.open().then( () => seenSaveDialog.value = true );

    }, { immediate: true } ) );

</script>

<template>

  <section class="bg-fixed bg-cover bg-center" :style="{ backgroundImage: `url( ${ backgroundPath } )` }">
    
    <div class="grid">

      <RouterView v-slot="{ Component }">
    
        <Transition

          enter-from-class="opacity-0"

          leave-to-class="opacity-0"

          enter-active-class="transition duration-300"

          leave-active-class="transition duration-300">

          <component :is="Component" class="row-start-1 col-start-1 min-h-view"/>
          
        </Transition>
        
      </RouterView>

    </div>

    <VideoPlayerDialog
    
      ref="playerDialog" eyebrow="Activity 1" heading="Hearing All the Stories"
    
      :src="videoPath" :tracks="[
        
        { default: true, src: captionsPath, kind: 'captions', label: 'English', srcLang: 'en' },

        { src: descriptionsPath, kind: 'descriptions', label: 'English', srcLang: 'en' }
        
      ]" />

    <SaveDialog ref="saveDialog" />

    <Teleport :to="buttons" v-if="buttons">

      <button type="button" class="flex items-center px-5 gap-2 h-full hover:underline focus-visible:underline" @click="playerDialog.open()">
        
        <PlayCircleIcon class="w-5" />

        <span class="text-sm">Replay Video</span>
      
      </button>

    </Teleport>

  </section>

</template>
